var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.pageTitle)+" ")]),_vm._t("table",null,{"tableSchema":_vm.tableSchema})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }